import { type MessageDescriptor } from 'react-intl';

import { jsmPortalPlaygroundMessages as messages } from './jsm-portal-playground-messages';

export type TeamTabValue = 'it-support' | 'it-operations' | 'engineering' | 'hr';

export type TeamTab = {
	label: MessageDescriptor;
	value: TeamTabValue;
};

export const teamTabs: TeamTab[] = [
	{ label: messages.teamItSupport, value: 'it-support' },
	{ label: messages.teamItOperations, value: 'it-operations' },
	{ label: messages.teamEngineering, value: 'engineering' },
	{ label: messages.teamHr, value: 'hr' },
];
